import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
import PropTypes from 'prop-types';

const ModalActualizarFechaVencimiento = ({
    showModal,
    setShowModal,
    ordenSeleccionada,
    onSuccessCallback
}) => {
    const { token } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [comentarioTexto, setComentarioTexto] = useState('');
    const [nuevaFechaPago, setNuevaFechaPago] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (showModal && ordenSeleccionada) {
            setComentarioTexto('');
            setNuevaFechaPago(ordenSeleccionada.dFechaVencimiento ? ordenSeleccionada.dFechaVencimiento.split('T')[0] : '');
        }
    }, [showModal, ordenSeleccionada]);

    const handleGuardarSeguimiento = async () => {
        if (!comentarioTexto.trim() || !nuevaFechaPago) {
            showErrorToast('Debes ingresar la razón y seleccionar la nueva fecha de pago.');
            return;
        }

        setIsSubmitting(true);
        try {
            // Actualizar la fecha de vencimiento (Promesa de pago)
            const resFecha = await fetch(`/api/orden/ActualizarFechaVencimientoOrden?idOrden=${ordenSeleccionada.idOrden}&dNuevaFechaVencimiento=${nuevaFechaPago}`, {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            });

            // Registrar el comentario
            const comentarioFinal = `[Promesa de pago: ${nuevaFechaPago}] ${comentarioTexto}`;
            const resComentario = await fetch(`/api/orden/RegistrarComentario?idOrden=${ordenSeleccionada.idOrden}&vComentario=${encodeURIComponent(comentarioFinal)}&idVendedor=${ordenSeleccionada.idUsuario || 0}&vEmailTrabajo=${ordenSeleccionada.vEmail || ''}&vNombreCliente=${encodeURIComponent(ordenSeleccionada.vNombreCliente || '')}&idTipoComentario=1`, {
                method: 'POST',
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            });

            if (resComentario.ok && resFecha.ok) {
                showSuccessToast('Seguimiento guardado correctamente');
                setShowModal(false);
                if (onSuccessCallback) {
                    onSuccessCallback();
                }
            } else {
                showErrorToast('Hubo un error al guardar los datos');
            }
        } catch (error) {
            showErrorToast('Ocurrió un error de conexión');
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!ordenSeleccionada) return null;

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton className="bg-light">
                <Modal.Title className="fs-1">Seguimiento de Orden #{ordenSeleccionada.idOrden}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semi-bold">Razón del retraso / Comentario</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Ej. El cliente pagará el fin de semana..."
                            value={comentarioTexto}
                            onChange={(e) => setComentarioTexto(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-semi-bold">Nueva Promesa de Pago</Form.Label>
                        <Form.Control
                            type="date"
                            min={new Date().toISOString().split('T')[0]}
                            value={nuevaFechaPago}
                            onChange={(e) => setNuevaFechaPago(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)} disabled={isSubmitting}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleGuardarSeguimiento} disabled={isSubmitting}>
                    {isSubmitting ? 'Guardando...' : 'Guardar Seguimiento'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalActualizarFechaVencimiento.propTypes = {
    showModal: PropTypes.bool.isRequired,
    setShowModal: PropTypes.func.isRequired,
    ordenSeleccionada: PropTypes.object,
    onSuccessCallback: PropTypes.func
};

export default ModalActualizarFechaVencimiento;
